export const BASE_URL = "https://static.draftbit.com/fonts/glyphmaps";
export const KEY = "iconSets";
export const ICON_FAMILIES = [
  { name: "AntDesign", label: "Ant Design", url: `${BASE_URL}/AntDesign.json` },
  { name: "Entypo", label: "Entypo", url: `${BASE_URL}/Entypo.json` },
  { name: "EvilIcons", label: "Evil Icons", url: `${BASE_URL}/EvilIcons.json` },
  { name: "Feather", label: "Feather", url: `${BASE_URL}/Feather.json` },
  {
    name: "FontAwesome",
    label: "Font Awesome",
    url: `${BASE_URL}/FontAwesome.json`,
  },
  {
    name: "Foundation",
    label: "Foundation",
    url: `${BASE_URL}/Foundation.json`,
  },
  { name: "Ionicons", label: "Ionicons", url: `${BASE_URL}/Ionicons.json` },
  {
    name: "MaterialCommunityIcons",
    label: "Material Community Icons",
    url: `${BASE_URL}/MaterialCommunityIcons.json`,
  },
  {
    name: "MaterialIcons",
    label: "Material Icons",
    url: `${BASE_URL}/MaterialIcons.json`,
  },
  { name: "Octicons", label: "Octicons", url: `${BASE_URL}/Octicons.json` },
  {
    name: "SimpleLineIcons",
    label: "Simple Line Icons",
    url: `${BASE_URL}/SimpleLineIcons.json`,
  },
  { name: "Zocial", label: "Zocial", url: `${BASE_URL}/Zocial.json` },
];
